import { TRANSITION_CANCELED } from '@/features/domaine/machine-etats'
import type { Dispositif } from '@/features/domaine/types/opco'
import { useAjouteDemande } from '@/features/interface/demande/ajouter/useAjouteDemande'
import { useDemandeRoutingService } from '@/features/interface/demande/shared/composables/useDemandeRoutingService'
import { useDialog } from '@/features/interface/dialog'
import * as api from '@/features/services/demande'
import type { CloneDemandeLaunch } from '../../demande/ajouter/CreationDemandeConfigurations'
import { useFavorisStore } from '../../favoris/favorisStore'
import { useRechercheDemandeStore } from './useRechercheDemandeStore'
import { SilentError } from '@/features/shared/types'

export function useRechercheDemandeActions() {
  const { navigateToWithId } = useDemandeRoutingService()
  const storeDemande = useRechercheDemandeStore()
  const storeAddDemande = useAjouteDemande()
  const { addFavori } = useFavorisStore()

  const dialog = useDialog()

  function ouvrirDemande(disposif: Dispositif, id: number) {
    navigateToWithId(disposif, id)
  }

  async function addDemande() {
    try {
      const demande = await storeAddDemande.showAjoute()
      navigateToWithId(demande.dispositif, demande.id)
    } catch (err) {
      if (err !== TRANSITION_CANCELED) throw err
      console.error(err)
    }
  }

  async function deleteDemande(dispositif: Dispositif, id: number) {
    const result = await dialog.showDialog({
      message: 'Confirmez-vous la suppression du brouillon.',
      type: 'YesNo',
      title: 'Supprimer un brouillon',
    })
    if (result === 'Yes') {
      await api.demandeService.deleteDemande(id, dispositif)
      await storeDemande.reloadData()
    }
  }

  async function addFavoris() {
    addFavori('demande', storeDemande.pageRequest!)
  }

  async function cloneDemande(options: CloneDemandeLaunch) {
    try {
      const demande = await storeAddDemande.showClone(options)
      navigateToWithId(demande.dispositif, demande.id)
    } catch (err) {
      if (err === TRANSITION_CANCELED) return
      if (err instanceof SilentError) return
      console.error(err)
    }
  }

  return { ouvrirDemande, deleteDemande, cloneDemande, addFavoris, addDemande }
}
